import styled from "styled-components";
import { CharterDetailAircraftCategory, CharterDetailHeader, CharterDetailLegInfo } from "@/components/molecules";
import { Col, Row } from "antd";

export function CardCharterDetail({ detail = {}, onShowDetails }) {
	return (
		<ContainerCharter data-testid="charterMyBookings_row">
			<CharterDetailHeader type={detail?.type} code={detail?.code} onShowDetails={() => onShowDetails(detail)} />
			<Row>
				<Col xl={7} lg={24} md={24} sm={24} xs={24}>
					<CharterDetailAircraftCategory
						aircraftCategories={detail?.aircraft_categories ?? []}
						type={detail?.type}
						aircraft={detail?.empty_leg?.aircraft || detail?.empty_leg_invited?.aircraft || {}}
					/>
				</Col>
				<Col xl={17} lg={24} md={24} sm={24} xs={24}>
					<CharterDetailLegInfo legs={detail?.legs} />
				</Col>
			</Row>
		</ContainerCharter>
	);
}

const ContainerCharter = styled.div`
	width: "100%";
	filter: drop-shadow(0px 4px 10px rgba(0, 0, 0, 0.06));
	@media (max-width: 768px) {
		border: 1px solid #e9e8e8;
		border-radius: 12px;
		filter: none;
	}
`;
